import { Weld } from '@bechtel/types';

export interface WeldClaimProps {
  isClaimAndApprove?: boolean;
  weld: Weld;
  close: () => void;
  isReclaim?: boolean;
  refetchQueries?: string[];
}
